<template>
  <ul :id="'pgwSlideshow' + image.imageId">
    <li>
      <img
        class="image-scale"
        :id="image.imageId"
        :src="getImageSrc(image)"
        :alt="image.alt"
        :data-description="image.dataDescription"
      />
    </li>
  </ul>
</template>

<script>
import $ from 'jquery';
import pgwSlideshow from '@/assets/js/pgwslideshow';

export default {
  name: 'tr-image',
  props: {
    image: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  beforeDestroy: function () {
    console.log('Image deactivate');
    if (this.image.backgroundSound) {
      this.$store.getters.modalImageBackgroundAudio.pause();
    }
    this.$store.commit('DEACTIVATE_MODALIMAGE');
  },
  mounted: function () {
    this.$store.commit('ACTIVATE_MODALIMAGE');
    console.log("$( '.modal-body' )", $('.modal-body.imageModalActiveClass'));
    console.log("$( '.modal-body' ).width()", $('.modal-body.imageModalActiveClass').width());
    this.$store.commit('CHANGE_CANVAS_WIDTH', $('.modal-body.imageModalActiveClass').width());
    this.$store.commit('CHANGE_CANVAS_HEIGHT', 960);
    let selector = '#pgwSlideshow' + this.image.imageId;
    // let height = $( '#' + this.image.imageId ).height();
    let height = $('.image-scale').height();
    console.log('height', height);
    // $( '.pgwSlideshow' ).pgwSlideshow( {
    $(selector).pgwSlideshow({
      // mainClassName: Array.prototype.slice.call( selector, 0, 1 ),
      // maxHeight: 1000 / this.$store.getters.scale,
      maxHeight: height,
      displayList: false,
    });
    if (this.image.backgroundSound) {
      var audio = document.createElement('audio');
      // audio.src = 'static/audio/test/test.mp3';
      audio.src = 'static/' + this.image.backgroundSound.src;
      this.$store.commit('SET_MODALIMAGE_BACKGROUND_AUDI', audio);
      audio.play();
    }
  },
  methods: {
    getImageSrc(data) {
      let imageSrc = data.imageSrc;
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
  },
  computed: {
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/css/pgwslideshow.css';
@import '~@/assets/sass/variable';

.image-modal-wrapper {
  .image-scale {
    height: $modalImagesContainerHeight;
    width: 1625px;
  }
  .modal-body {
    margin: 20px 0;
    .pgwSlideshow {
      background: #fff;
    }
  }
  .ps-current {
    ul {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      height: 100% !important;
      width: 100% !important;
      padding: 0 !important;
      li {
        img {
        }
      }
    }
  }
}
</style>
